module.exports = ".modal{max-height:100vh;overflow:auto}\n"